// import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

 
// const api = axios.create({
//     baseURL: API_BASE_URL,
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });

export interface WalletDetails {
    address: string;
    currentBalance: number;
}

export interface InvestorDetails extends WalletDetails {
    name: string;
    mainWallet: string;
    initialBalance: number;
    createdAt: string;
    updatedAt: string;
}

export interface StakingInfo {
    totalBalance: number;
    activeWallets: number;
    totalWallets: number;
    wallets: Array<{
        walletAddress: string;
        balance: number;
    }>;
}

export interface TransferStats {
    totalSent: number;
    totalReceived: number;
    uniqueRecipients: number;
    uniqueSenders: number;
    totalTransfers: number;
}

export interface Transaction {
    signature: string;
    fromWallet: string;
    toWallet: string;
    amount: number;
    type: 'TRANSFER' | 'STAKE' | 'UNSTAKE';
    timestamp: string;
    preBalance?: number;
    postBalance?: number;
}

export interface PaginationInfo {
    currentPage: number;
    totalPages: number;
    totalTransactions: number;
    hasMore: boolean;
    pageSize: number;
}

export interface TransactionHistoryResponse {
    transactions: Transaction[];
    pagination: PaginationInfo;
}

export interface WalletAnalysis {
    walletDetails: WalletDetails;
    investorDetails?: InvestorDetails;
    staking?: StakingInfo;
    transfers: TransferStats;
    transactions: Transaction[];
}

export const walletApi = {
    analyzeWallet: async (address: string, pageSize: number = 100) => {
        const response = await fetch(`${API_BASE_URL}/wallet/${address}?pageSize=${pageSize}`);
        return response.json();
    },

    getTransactionHistory: (address: string, page: number = 1, pageSize: number = 100): EventSource => {
        return new EventSource(`${API_BASE_URL}/wallet/${address}/transactions?page=${page}&pageSize=${pageSize}`);
    },

    getWalletBalance: async (address: string): Promise<{ address: string; balance: number }> => {
        const response = await fetch(`${API_BASE_URL}/wallet/${address}/balance`);
        if (!response.ok) throw new Error('Failed to get wallet balance');
        return response.json();
    },

    getTransactionFlow: async (signature: string, depth: number = 2): Promise<{ 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        flow: any[]; 
        depth: number 
    }> => {
        const response = await fetch(`${API_BASE_URL}/wallet/flow/${signature}?depth=${depth}`);
        if (!response.ok) throw new Error('Failed to get transaction flow');
        return response.json();
    }
}; 